export function prepareError(source: Error): { [key: string]: string } {
  const error = {};

  Object.getOwnPropertyNames(source).forEach(key => (error[key] = source[key]));

  return error;
}



// WEBPACK FOOTER //
// ./src/utils/ErrorUtils.ts